import { render, staticRenderFns } from "./TagMenu.vue?vue&type=template&id=0eff6e8e&scoped=true"
import script from "./TagMenu.vue?vue&type=script&lang=js"
export * from "./TagMenu.vue?vue&type=script&lang=js"
import style0 from "./TagMenu.vue?vue&type=style&index=0&id=0eff6e8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eff6e8e",
  null
  
)

export default component.exports